<template>
  <div class="cq-menubarbtn">
    <b-button class= "mbtn" :class="{ 'rightbtn': rightside,'join': !last, 'right-border': curvedend, 'left-border': curvedfront}">{{ menubarbtn }}</b-button>
  </div>
</template>

<script>
export default {
  name:'cq-menubarright',
  props:{
    menubarbtn: {},
    last: {
      default: false
    },
    curvedend: {
      default: false
    },
    curvedfront: {
      default: false
    },
    rightside: {
      default: false
    }
  }
}
</script>

<style>
.join:after{
    content: '';
    top: -1px;
    right:-20px;
    position: absolute;
    background: #929292;
    height: 3px;
    width: 30px;
  }


  .join:before{
    content: '';
    bottom: -1px;
    right:-20px;
    position: absolute;
    background: #4b4b4b;
    height: 3px;
    width: 30px;
  }

@media only screen and (min-width: 992px){
  .cq-menubarbtn{
    display: inline-block;
  }

  .mbtn{
    background-color: var(--tertiary-color) !important;
    float:left;
    font-size: 17px !important;
    margin-left: 1px;
    position: relative;
    border-radius: 0;
    padding: 3px 42px !important;
    color: #fff;
    background-image: linear-gradient(#9b9b9b, #646464 , #4b4b4b);
    margin-top: 19px; 
  }

  .right-border {
    padding-right: 50px !important;
    border-top-right-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
  }

  .left-border {
    /* padding-right: 100px !important; */
    /* padding-left:  30px !important; */
    border-top-left-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
  }

  .rightbtn{
    margin-right: -20px; 
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1174px) and (max-width: 1274px) {
  .cq-menubarbtn{
    display: inline-block;
  }

  .mbtn{
    background-color: var(--tertiary-color) !important;
    float:left;
    font-size: 17px !important;
    margin-left: 1px;
    position: relative;
    border-radius: 0;
    padding: 3px 32px !important;
    color: #fff;
    background-image: linear-gradient(#9b9b9b, #646464 , #4b4b4b);
    margin-top: 19px; 
  }
}

@media only screen and (min-width: 992px) and (max-width: 1174px) {
  .cq-menubarbtn{
    display: inline-block;
  }

  .mbtn{
    background-color: var(--tertiary-color) !important;
    float:left;
    font-size: 17px !important;
    margin-left: 1px;
    position: relative;
    border-radius: 0;
    padding: 3px 22px !important;
    color: #fff;
    background-image: linear-gradient(#9b9b9b, #646464 , #4b4b4b);
    margin-top: 19px; 
  }
}

@media only screen and (min-width: 1074px) and (max-width: 1174px) {
  .cq-menubarbtn{
    display: inline-block;
  }

  .mbtn{
    background-color: var(--tertiary-color) !important;
    float:left;
    font-size: 17px !important;
    margin-left: 1px;
    position: relative;
    border-radius: 0;
    padding: 3px 12px !important;
    color: #fff;
    background-image: linear-gradient(#9b9b9b, #646464 , #4b4b4b);
    margin-top: 19px; 
  }
}

@media only screen and (min-width: 992px) and (max-width: 1074px) {
  .cq-menubarbtn{
    display: inline-block;
  }

  .mbtn{
    background-color: var(--tertiary-color) !important;
    float:left;
    font-size: 17px !important;
    margin-left: 1px;
    position: relative;
    border-radius: 0;
    padding: 3px 5px !important;
    color: #fff;
    background-image: linear-gradient(#9b9b9b, #646464 , #4b4b4b);
    margin-top: 19px; 
  }
}
</style>
